// extracted by mini-css-extract-plugin
export default {"wrapper":"Sea","container":"Tea","box":"Uea","title":"Vea","rdwrap":"Wea","rditem":"Xea","rdimage":"Yea","name":"Zea","heading":"afa","text":"bfa","guarantee":"cfa","chatbox":"efa"};
    if(module.hot) {
      // 1737143665394
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  